export function initDraggableModals() {
  const styleEl = document.createElement('style');
  styleEl.textContent = `
    .modal-header { cursor: grab; }
    .modal-dialog-dragging .modal-header { cursor: grabbing; }
    .modal-dialog-dragging { user-select: none; }
  `;
  document.head.appendChild(styleEl);

  let drag = null;

  document.addEventListener('mousedown', (e) => {
    const header = e.target.closest('.modal-header');
    if (!header) return;

    // Não inicia o drag ao clicar em elementos interativos do cabeçalho
    if (e.target.closest('button, input, select, textarea, a, [role="button"]')) return;

    const dialog = header.closest('.modal-dialog');
    if (!dialog) return;

    const raw = window.getComputedStyle(dialog).transform;
    const matrix = raw === 'none' ? { m41: 0, m42: 0 } : new DOMMatrixReadOnly(raw);

    drag = {
      dialog,
      x0: e.clientX,
      y0: e.clientY,
      tx: matrix.m41,
      ty: matrix.m42,
    };

    dialog.classList.add('modal-dialog-dragging');
    e.preventDefault();
  });

  document.addEventListener('mousemove', (e) => {
    if (!drag) return;
    const tx = drag.tx + (e.clientX - drag.x0);
    const ty = drag.ty + (e.clientY - drag.y0);
    drag.dialog.style.transform = `translate(${tx}px, ${ty}px)`;
  });

  document.addEventListener('mouseup', () => {
    if (drag) {
      drag.dialog.classList.remove('modal-dialog-dragging');
      drag = null;
    }
  });
}
